export default __webpack_public_path__ + "1c75f70a294b24a6820c905cf1e85b98.svg";